export const enTrTB = {
  travel_dates: 'Travel dates',
  duration: 'Duration',
  night: 'night',
  nights: 'nights',
  travellers: 'Travellers',
  destinations: 'Destinations',
  quote_valid: 'Quote valid',
  proposal_full: 'Proposal',
  your_selection: 'Your Selection',
  selection_hint: 'Pick hotels above — your total updates live.',
  selected: 'SELECTED',
  selection_count: '{{selected}} of {{total}} selected',
  no_hotels_selected: 'No hotels selected yet',
  choose_from_above: 'Choose from options above',
  grand_total: 'Grand total · Selected options',
  hotels_selected_count_one: '{{count}} hotel selected',
  hotels_selected_count_other: '{{count}} hotels selected',
  no_hotels_selected_short: 'No hotels selected',
  total_charge_note: 'Prices include all nights. Nothing is charged until you confirm with Julia.',
  submit_selection_to_agent: 'Submit to Agent',
  send_to_agent: 'Send to agent',
  whatsapp_message: 'Pdf: {{url}}\nDetails: {{link}}',
  telegram_message: 'Pdf: {{url}}\nDetails: {{siteUrl}}',
  download_pdf: 'Download PDF',
  your_itinerary: 'Your Itinerary',
  close: 'Close',
  route: 'Route',
  your_route: 'Your Route',
  route_hint: 'Click the button below to open your full route in Google Maps.',
  hotel: 'Hotel',
  airport: 'Airport',
  open_in_google_maps: 'Open in Google Maps',
  select_to_see_route: 'Select flights and hotels to see your route.',
  departure: 'Departure — {{label}}',
  arrival: 'Arrival — {{label}}',
  option: 'OPTION {{letter}}',
  total_stay: 'total stay',
  details_and_photos: 'Details & Photos',
  no_hotel_selected: 'No hotel selected',
  select_mandatory_warning: 'Please select all mandatory items before saving.',
  something_went_wrong: 'Something went wrong',
  no_hotels_in_proposal: 'No hotels in proposal',
  flights: 'Flights',
  your_flights: 'Your Flights',
  itinerary: 'Itinerary',
  itinerary_hint: 'Select one hotel per destination — your grand total updates instantly.',
  select_preferred_hotel: 'SELECT YOUR PREFERRED HOTEL',
  transfers_in_city: 'Transfers and attractions in {{city}}',
  select_preferred_transfer: 'SELECT YOUR PREFERRED TRANSFER',
  no_transfer_selected: 'No transfer selected',
  password_lock_title: 'Protected proposal',
  trip_builder: {
    client_name: 'Client name',
    passenger_composition: 'Passenger composition',
    offer_number: 'Offer number',
    agent_name: 'Agent name',
    agent_details: 'Agent details',
    vacation_date: 'Vacation date',
    scroll_to_itinerary: 'To the full itinerary',
    free_cancellation_until: 'Free cancellation until {{date}}',
    full_cancellation_fee: 'Full cancellation fee',
    hotel_for_selection: 'Hotel for selection',
    close_hotels: 'Close hotels',
    open_hotels: 'Open hotels',
    check_in: 'Check-in',
    check_out: 'Check-out',
    total_nights: 'Total {{count}} {{nightsLabel}}',
    per_night: '{{price}} per night',
    total_price: '{{price}} total',
    select_hotel: 'Select',
    hotel_map_available: 'Available',
    hotel_details_link: 'Hotel details...',
    back: 'Back',
    hotels_cta_title_line1: 'Customize the trip with select hotels',
    hotels_cta_title_line2: 'intended for you',
    send_route: 'Send route',
    why_flyeast_title: 'Why FlyEast?',
    why_flyeast_feature_1: 'Local branch in Thailand and personal service in Hebrew',
    why_flyeast_feature_2: 'Tailor-made vacation customization for your dreams',
    why_flyeast_feature_3: 'Vacation matching for every group and style',
    why_flyeast_feature_4: 'Personal guidance all the way and solutions for any issue',
    testimonials_title: 'What our customers say matters to us...',
    testimonials_subtitle: 'Flyeast customer reviews',
    testimonials_prev: 'Previous review',
    testimonials_next: 'Next review',
    testimonial_1_initials: 'SD',
    testimonial_1_name: 'Shlomi Davidi',
    testimonial_1_location: 'Thailand, Bangkok',
    testimonial_1_text:
      'Flyeast planned our family trip perfectly — hotels, flights, and personal support in Hebrew throughout. Highly recommended!',
    testimonial_2_initials: 'MR',
    testimonial_2_name: 'Maya Rosen',
    testimonial_2_location: 'Thailand, Phuket',
    testimonial_2_text:
      'Professional, attentive, and truly tailored to what we wanted. Every detail was taken care of from start to finish.',
  },
  mo: {
    email_success: 'Email sent successfully',
  },
};

export const heTrTB = {
  travel_dates: 'תאריכי הנסיעה',
  duration: 'משך',
  night: 'לילה',
  nights: 'לילות',
  travellers: 'מטיילים',
  destinations: 'יעדים',
  quote_valid: 'הצעת מחיר בתוקף',
  proposal_full: 'הצעת מחיר',
  your_selection: 'הבחירה שלך',
  selection_hint: 'בחרו מלונות למעלה — הסכום מתעדכן בזמן אמת.',
  selected: 'נבחר',
  selection_count: '{{selected}} מתוך {{total}} נבחרו',
  no_hotels_selected: 'עדיין לא נבחרו מלונות',
  choose_from_above: 'בחרו מהאפשרויות למעלה',
  grand_total: 'סה״כ · אפשרויות שנבחרו',
  hotels_selected_count_one: 'מלון {{count}} נבחר',
  hotels_selected_count_other: '{{count}} מלונות נבחרו',
  no_hotels_selected_short: 'לא נבחרו מלונות',
  total_charge_note: 'המחירים כוללים את כל הלילות. לא תחויבו עד שתאשרו עם Julia.',
  submit_selection_to_agent: 'שליחה לסוכן',
  send_to_agent: 'שליחה לסוכן',
  whatsapp_message: 'Pdf: {{url}}\nפרטים: {{link}}',
  telegram_message: 'Pdf: {{url}}\nפרטים: {{siteUrl}}',
  download_pdf: 'הורדת PDF',
  your_itinerary: 'המסלול שלך',
  close: 'סגור',
  route: 'מסלול',
  your_route: 'המסלול שלך',
  route_hint: 'לחצו על הכפתור למטה כדי לפתוח את המסלול המלא ב-Google Maps.',
  hotel: 'מלון',
  airport: 'שדה תעופה',
  open_in_google_maps: 'פתיחה ב-Google Maps',
  select_to_see_route: 'בחרו טיסות ומלונות כדי לראות את המסלול.',
  departure: 'יציאה — {{label}}',
  arrival: 'הגעה — {{label}}',
  option: 'אפשרות {{letter}}',
  total_stay: 'סה״כ שהייה',
  details_and_photos: 'פרטים ותמונות',
  no_hotel_selected: 'לא נבחר מלון',
  select_mandatory_warning: 'יש לבחור את כל הפריטים החובה לפני השמירה.',
  something_went_wrong: 'משהו השתבש',
  no_hotels_in_proposal: 'אין מלונות בהצעה',
  flights: 'טיסות',
  your_flights: 'הטיסות שלך',
  itinerary: 'מסלול',
  itinerary_hint: 'בחרו מלון אחד לכל יעד — הסכום הכולל מתעדכן מיד.',
  select_preferred_hotel: 'בחרו את המלון המועדף עליכם',
  transfers_in_city: 'הסעות ואטרקציות ב{{city}}',
  select_preferred_transfer: 'בחרו את ההסעה המועדפת עליכם',
  no_transfer_selected: 'לא נבחרה הסעה',
  password_lock_title: 'הצעה מוגנת',
  trip_builder: {
    client_name: 'שם לקוח',
    passenger_composition: 'הרכב נוסעים',
    offer_number: 'מספר הצעה',
    agent_name: 'שם הסוכן',
    agent_details: 'פרטי סוכן',
    vacation_date: 'תאריכי החופשה',
    scroll_to_itinerary: 'למסלול המלא',
    free_cancellation_until: 'ביטול חינם עד {{date}}',
    full_cancellation_fee: 'דמי ביטול מלאים',
    hotel_for_selection: 'מלון לבחירה',
    close_hotels: 'סגור מלונות',
    open_hotels: 'פתח מלונות',
    check_in: "צ'ק אין",
    check_out: "צ'ק אאוט",
    total_nights: 'סה"כ {{count}} {{nightsLabel}}',
    per_night: '{{price}} ללילה',
    total_price: '{{price}} סה"כ',
    select_hotel: 'בחירה',
    hotel_map_available: 'זמין',
    hotel_details_link: 'פירוט המלון...',
    back: 'חזור',
    hotels_cta_title_line1: 'התאימו את הטיול עם מלונות',
    hotels_cta_title_line2: 'מובחרים שמיועדים לכם',
    send_route: 'שליחת מסלול',
    why_flyeast_title: 'למה FlyEast?',
    why_flyeast_feature_1: 'סניף מקומי בתאילנד ושירות אישי בעברית',
    why_flyeast_feature_2: 'התאמת החופשה בתפירה אישית לחלומות שלכם',
    why_flyeast_feature_3: 'התאמת חופשה לכל הרכב וסגנון',
    why_flyeast_feature_4: 'ליווי אישי לאורך כל הדרך ומתן פתרונות בכל סוגיה',
    testimonials_title: 'חשוב לנו מה אומרים עלינו...',
    testimonials_subtitle: 'המלצות של לקוחות על Flyeast',
    testimonials_prev: 'ביקורת קודמת',
    testimonials_next: 'ביקורת הבאה',
    testimonial_1_initials: 'שד',
    testimonial_1_name: 'שלומי דוידי',
    testimonial_1_location: 'תאילנד, בנגקוק',
    testimonial_1_text:
      'Flyeast תכננו לנו את החופשה המשפחתית בצורה מושלמת — מלונות, טיסות וליווי אישי בעברית לאורך כל הדרך. ממליצים בחום!',
    testimonial_2_initials: 'מר',
    testimonial_2_name: 'מאיה רוזן',
    testimonial_2_location: 'תאילנד, פוקט',
    testimonial_2_text: 'מקצועיים, קשובים ובאמת מותאמים למה שרצינו. כל פרט טופל מההתחלה ועד הסוף.',
  },
  mo: {
    email_success: 'האימייל נשלח בהצלחה',
  },
};

export const esTrTB = {
  travel_dates: 'Fechas de viaje',
  duration: 'Duración',
  night: 'noche',
  nights: 'noches',
  travellers: 'Viajeros',
  destinations: 'Destinos',
  quote_valid: 'Cotización válida',
  proposal_full: 'Propuesta',
  your_selection: 'Tu selección',
  selection_hint: 'Elige hoteles arriba — el total se actualiza en vivo.',
  selected: 'SELECCIONADO',
  selection_count: '{{selected}} de {{total}} seleccionados',
  no_hotels_selected: 'Aún no hay hoteles seleccionados',
  choose_from_above: 'Elige entre las opciones de arriba',
  grand_total: 'Total general · Opciones seleccionadas',
  hotels_selected_count_one: '{{count}} hotel seleccionado',
  hotels_selected_count_other: '{{count}} hoteles seleccionados',
  no_hotels_selected_short: 'Sin hoteles seleccionados',
  total_charge_note:
    'Los precios incluyen todas las noches. No se cobra nada hasta que confirmes con Julia.',
  submit_selection_to_agent: 'Enviar al agente',
  send_to_agent: 'Enviar al agente',
  whatsapp_message: 'Pdf: {{url}}\nDetalles: {{link}}',
  telegram_message: 'Pdf: {{url}}\nDetalles: {{siteUrl}}',
  download_pdf: 'Descargar PDF',
  your_itinerary: 'Tu itinerario',
  close: 'Cerrar',
  route: 'Ruta',
  your_route: 'Tu ruta',
  route_hint: 'Haz clic en el botón de abajo para abrir tu ruta completa en Google Maps.',
  hotel: 'Hotel',
  airport: 'Aeropuerto',
  open_in_google_maps: 'Abrir en Google Maps',
  select_to_see_route: 'Selecciona vuelos y hoteles para ver tu ruta.',
  departure: 'Salida — {{label}}',
  arrival: 'Llegada — {{label}}',
  option: 'OPCIÓN {{letter}}',
  total_stay: 'estancia total',
  details_and_photos: 'Detalles y fotos',
  no_hotel_selected: 'Ningún hotel seleccionado',
  select_mandatory_warning: 'Selecciona todos los elementos obligatorios antes de guardar.',
  something_went_wrong: 'Algo salió mal',
  no_hotels_in_proposal: 'No hay hoteles en la propuesta',
  flights: 'Vuelos',
  your_flights: 'Tus vuelos',
  itinerary: 'Itinerario',
  itinerary_hint: 'Selecciona un hotel por destino — el total se actualiza al instante.',
  select_preferred_hotel: 'SELECCIONA TU HOTEL PREFERIDO',
  transfers_in_city: 'Traslados y atracciones en {{city}}',
  select_preferred_transfer: 'SELECCIONA TU TRASLADO PREFERIDO',
  no_transfer_selected: 'Ningún traslado seleccionado',
  trip_builder: {
    client_name: 'Nombre del cliente',
    passenger_composition: 'Composición de pasajeros',
    offer_number: 'Número de oferta',
    agent_name: 'Nombre del agente',
    agent_details: 'Detalles del agente',
    vacation_date: 'Fecha de vacaciones',
    scroll_to_itinerary: 'Al itinerario completo',
    free_cancellation_until: 'Cancelación gratuita hasta {{date}}',
    full_cancellation_fee: 'Tarifa de cancelación completa',
    hotel_for_selection: 'Hotel a elegir',
    close_hotels: 'Cerrar hoteles',
    open_hotels: 'Abrir hoteles',
    check_in: 'Check-in',
    check_out: 'Check-out',
    total_nights: 'Total {{count}} {{nightsLabel}}',
    per_night: '{{price}} por noche',
    total_price: '{{price}} total',
    select_hotel: 'Seleccionar',
    hotel_map_available: 'Disponible',
    hotel_details_link: 'Detalles del hotel...',
    back: 'Volver',
    hotels_cta_title_line1: 'Personaliza el viaje con hoteles selectos',
    hotels_cta_title_line2: 'pensados para ti',
    send_route: 'Enviar ruta',
    why_flyeast_title: '¿Por qué FlyEast?',
    why_flyeast_feature_1: 'Sucursal local en Tailandia y servicio personal en hebreo',
    why_flyeast_feature_2: 'Vacaciones a medida según tus sueños',
    why_flyeast_feature_3: 'Vacaciones adaptadas a cada grupo y estilo',
    why_flyeast_feature_4: 'Acompañamiento personal y soluciones para cualquier situación',
    testimonials_title: 'Nos importa lo que dicen de nosotros...',
    testimonials_subtitle: 'Opiniones de clientes sobre Flyeast',
    testimonials_prev: 'Reseña anterior',
    testimonials_next: 'Siguiente reseña',
    testimonial_1_initials: 'SD',
    testimonial_1_name: 'Shlomi Davidi',
    testimonial_1_location: 'Tailandia, Bangkok',
    testimonial_2_initials: 'MR',
    testimonial_2_name: 'Maya Rosen',
    testimonial_2_location: 'Tailandia, Phuket',
  },
  mo: {
    email_success: 'El correo se ha enviado correctamente',
  },
};

export const itTrTB = {
  travel_dates: 'Date di viaggio',
  duration: 'Durata',
  night: 'notte',
  nights: 'notti',
  travellers: 'Viaggiatori',
  destinations: 'Destinazioni',
  quote_valid: 'Preventivo valido',
  proposal_full: 'Proposta',
  your_selection: 'La tua selezione',
  selection_hint: 'Scegli gli hotel sopra — il totale si aggiorna in tempo reale.',
  selected: 'SELEZIONATO',
  selection_count: '{{selected}} di {{total}} selezionati',
  no_hotels_selected: 'Nessun hotel selezionato',
  choose_from_above: 'Scegli tra le opzioni sopra',
  grand_total: 'Totale · Opzioni selezionate',
  hotels_selected_count_one: '{{count}} hotel selezionato',
  hotels_selected_count_other: '{{count}} hotel selezionati',
  no_hotels_selected_short: 'Nessun hotel selezionato',
  total_charge_note:
    'I prezzi includono tutte le notti. Nulla viene addebitato finché non confermi con Julia.',
  submit_selection_to_agent: "Invia all'agente",
  send_to_agent: "Invia all'agente",
  whatsapp_message: 'Pdf: {{url}}\nDettagli: {{link}}',
  telegram_message: 'Pdf: {{url}}\nDettagli: {{siteUrl}}',
  download_pdf: 'Scarica PDF',
  your_itinerary: 'Il tuo itinerario',
  close: 'Chiudi',
  route: 'Percorso',
  your_route: 'Il tuo percorso',
  route_hint: 'Clicca il pulsante qui sotto per aprire il percorso completo in Google Maps.',
  hotel: 'Hotel',
  airport: 'Aeroporto',
  open_in_google_maps: 'Apri in Google Maps',
  select_to_see_route: 'Seleziona voli e hotel per vedere il percorso.',
  departure: 'Partenza — {{label}}',
  arrival: 'Arrivo — {{label}}',
  option: 'OPZIONE {{letter}}',
  total_stay: 'soggiorno totale',
  details_and_photos: 'Dettagli e foto',
  no_hotel_selected: 'Nessun hotel selezionato',
  select_mandatory_warning: 'Seleziona tutti gli elementi obbligatori prima di salvare.',
  something_went_wrong: 'Qualcosa è andato storto',
  no_hotels_in_proposal: 'Nessun hotel nella proposta',
  flights: 'Voli',
  your_flights: 'I tuoi voli',
  itinerary: 'Itinerario',
  itinerary_hint: 'Seleziona un hotel per destinazione — il totale si aggiorna istantaneamente.',
  select_preferred_hotel: 'SELEZIONA IL TUO HOTEL PREFERITO',
  transfers_in_city: 'Transfer e attrazioni a {{city}}',
  select_preferred_transfer: 'SELEZIONA IL TUO TRANSFER PREFERITO',
  no_transfer_selected: 'Nessun transfer selezionato',
  trip_builder: {
    client_name: 'Nome cliente',
    passenger_composition: 'Composizione passeggeri',
    offer_number: 'Numero offerta',
    agent_name: 'Nome agente',
    agent_details: 'Dettagli agente',
    vacation_date: 'Data vacanza',
    scroll_to_itinerary: "All'itinerario completo",
    free_cancellation_until: 'Cancellazione gratuita fino al {{date}}',
    full_cancellation_fee: 'Penale di cancellazione totale',
    hotel_for_selection: 'Hotel a scelta',
    close_hotels: 'Chiudi hotel',
    open_hotels: 'Apri hotel',
    check_in: 'Check-in',
    check_out: 'Check-out',
    total_nights: 'Totale {{count}} {{nightsLabel}}',
    per_night: '{{price}} a notte',
    total_price: '{{price}} totale',
    select_hotel: 'Seleziona',
    hotel_map_available: 'Disponibile',
    hotel_details_link: 'Dettagli hotel...',
    back: 'Indietro',
    hotels_cta_title_line1: 'Personalizza il viaggio con hotel selezionati',
    hotels_cta_title_line2: 'pensati per te',
    send_route: 'Invia percorso',
    why_flyeast_title: 'Perché FlyEast?',
    why_flyeast_feature_1: 'Filiale locale in Thailandia e servizio personale in ebraico',
    why_flyeast_feature_2: 'Vacanza su misura per i vostri sogni',
    why_flyeast_feature_3: 'Vacanza adatta a ogni gruppo e stile',
    why_flyeast_feature_4:
      'Assistenza personale lungo tutto il percorso e soluzioni per ogni esigenza',
    testimonials_title: 'Per noi conta ciò che dicono di noi...',
    testimonials_subtitle: 'Recensioni dei clienti su Flyeast',
    testimonials_prev: 'Recensione precedente',
    testimonials_next: 'Recensione successiva',
    testimonial_1_initials: 'SD',
    testimonial_1_name: 'Shlomi Davidi',
    testimonial_1_location: 'Thailandia, Bangkok',
    testimonial_2_initials: 'MR',
    testimonial_2_name: 'Maya Rosen',
    testimonial_2_location: 'Thailandia, Phuket',
  },
  mo: {
    email_success: "L'email è stata inviata con successo",
  },
};

export const frTrTB = {
  travel_dates: 'Dates de voyage',
  duration: 'Durée',
  night: 'nuit',
  nights: 'nuits',
  travellers: 'Voyageurs',
  destinations: 'Destinations',
  quote_valid: 'Devis valable',
  proposal_full: 'Proposition',
  your_selection: 'Votre sélection',
  selection_hint: 'Choisissez des hôtels ci-dessus — le total se met à jour en direct.',
  selected: 'SÉLECTIONNÉ',
  selection_count: '{{selected}} sur {{total}} sélectionnés',
  no_hotels_selected: 'Aucun hôtel sélectionné',
  choose_from_above: 'Choisissez parmi les options ci-dessus',
  grand_total: 'Total · Options sélectionnées',
  hotels_selected_count_one: '{{count}} hôtel sélectionné',
  hotels_selected_count_other: '{{count}} hôtels sélectionnés',
  no_hotels_selected_short: 'Aucun hôtel sélectionné',
  total_charge_note:
    "Les prix incluent toutes les nuits. Rien n'est facturé tant que vous n'avez pas confirmé avec Julia.",
  submit_selection_to_agent: "Envoyer à l'agent",
  send_to_agent: "Envoyer à l'agent",
  whatsapp_message: 'Pdf: {{url}}\nDétails: {{link}}',
  telegram_message: 'Pdf: {{url}}\nDétails: {{siteUrl}}',
  download_pdf: 'Télécharger le PDF',
  your_itinerary: 'Votre itinéraire',
  close: 'Fermer',
  route: 'Itinéraire',
  your_route: 'Votre itinéraire',
  route_hint:
    'Cliquez sur le bouton ci-dessous pour ouvrir votre itinéraire complet dans Google Maps.',
  hotel: 'Hôtel',
  airport: 'Aéroport',
  open_in_google_maps: 'Ouvrir dans Google Maps',
  select_to_see_route: 'Sélectionnez des vols et des hôtels pour voir votre itinéraire.',
  departure: 'Départ — {{label}}',
  arrival: 'Arrivée — {{label}}',
  option: 'OPTION {{letter}}',
  total_stay: 'séjour total',
  details_and_photos: 'Détails et photos',
  no_hotel_selected: 'Aucun hôtel sélectionné',
  select_mandatory_warning:
    'Veuillez sélectionner tous les éléments obligatoires avant de sauvegarder.',
  something_went_wrong: 'Une erreur est survenue',
  no_hotels_in_proposal: 'Aucun hôtel dans la proposition',
  flights: 'Vols',
  your_flights: 'Vos vols',
  itinerary: 'Itinéraire',
  itinerary_hint: 'Sélectionnez un hôtel par destination — le total se met à jour instantanément.',
  select_preferred_hotel: 'SÉLECTIONNEZ VOTRE HÔTEL PRÉFÉRÉ',
  transfers_in_city: 'Transferts et attractions à {{city}}',
  select_preferred_transfer: 'SÉLECTIONNEZ VOTRE TRANSFERT PRÉFÉRÉ',
  no_transfer_selected: 'Aucun transfert sélectionné',
  trip_builder: {
    client_name: 'Nom du client',
    passenger_composition: 'Composition des passagers',
    offer_number: 'Numéro de devis',
    agent_name: "Nom de l'agent",
    agent_details: "Coordonnées de l'agent",
    vacation_date: 'Date des vacances',
    scroll_to_itinerary: "Vers l'itinéraire complet",
    free_cancellation_until: "Annulation gratuite jusqu'au {{date}}",
    full_cancellation_fee: "Frais d'annulation complets",
    hotel_for_selection: 'Hôtel au choix',
    close_hotels: 'Fermer les hôtels',
    open_hotels: 'Ouvrir les hôtels',
    check_in: 'Arrivée',
    check_out: 'Départ',
    total_nights: 'Total {{count}} {{nightsLabel}}',
    per_night: '{{price}} par nuit',
    total_price: '{{price}} total',
    select_hotel: 'Choisir',
    hotel_map_available: 'Disponible',
    hotel_details_link: "Détails de l'hôtel...",
    back: 'Retour',
    hotels_cta_title_line1: 'Personnalisez le voyage avec des hôtels sélectionnés',
    hotels_cta_title_line2: 'pensés pour vous',
    send_route: "Envoyer l'itinéraire",
    why_flyeast_title: 'Pourquoi FlyEast ?',
    why_flyeast_feature_1: 'Agence locale en Thaïlande et service personnalisé en hébreu',
    why_flyeast_feature_2: 'Vacances sur mesure selon vos rêves',
    why_flyeast_feature_3: 'Vacances adaptées à chaque groupe et style',
    why_flyeast_feature_4: 'Accompagnement personnel et solutions pour toute situation',
    testimonials_title: 'Ce que nos clients disent compte pour nous...',
    testimonials_subtitle: 'Avis clients sur Flyeast',
    testimonials_prev: 'Avis précédent',
    testimonials_next: 'Avis suivant',
    testimonial_1_initials: 'SD',
    testimonial_1_name: 'Shlomi Davidi',
    testimonial_1_location: 'Thaïlande, Bangkok',
    testimonial_2_initials: 'MR',
    testimonial_2_name: 'Maya Rosen',
    testimonial_2_location: 'Thaïlande, Phuket',
  },
  mo: {
    email_success: "L'email è stata inviata con successo",
  },
};
